import React, { useEffect } from 'react';
import { AboutHero, ApproachSection, DirectorSection, AdvisorySection, Introduction } from '../components/about';

const About: React.FC = () => {
  useEffect(() => {
    document.body.classList.add('about-page');
    return () => {
      document.body.classList.remove('about-page');
    };
  }, []);

  return (
    <main id="main-content" role="main" style={{ position: 'relative', minHeight: '100vh' }}>
      <div className="layout-content" style={{ position: 'relative', zIndex: 1 }}>
        <AboutHero />
        <Introduction />
        {/* Our Mission Section */}
        <section className="about-mission-section py-5" style={{ display: 'none' }}>
          <div className="container">
            <div className="row justify-content-center" style={{ display: 'none' }}>
              <div className="col-lg-10">
                <p
                  className="about-mission-text mb-0 text-center"
                  style={{
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    maxWidth: '100%',
                    fontSize: '1.8rem',
                    lineHeight: 1.8,
                    color: '#273351'
                  }}
                >
                  The HKUST AI Literacy Hub is a program partnered with the Solomon Learning Group for community outreach
                  on AI literacy education. It is spearheaded by Dr. Jac Leung. The program's design aims to foster AI
                  understanding and application within the educational community, specifically targeting primary and secondary
                  schools in Hong Kong. Our core mission is to empower educators and students through explainable, ethical,
                  and responsible use of AI.
                </p>
              </div>
            </div>
          </div>
        </section>
        <ApproachSection />
        <DirectorSection />
        <AdvisorySection />
      </div>
    </main>
  );
};

export default About;

